<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700"
    @keydown.esc="close()"
  >
    <v-card>

      <v-system-bar
        status
        color="black"
        class="pa-0"
      >
        <div style="color:#FFF; width:100%; text-align:center;">{{getTitolo}}</div>
        <v-spacer></v-spacer>
        <v-btn
        text
          icon
          @click="close"
          class="ma-0"
        >
          <v-icon
            small
            color="white"
          >close</v-icon>
        </v-btn>

      </v-system-bar>

      <v-carousel v-model="currentIndex">
        <v-carousel-item
          v-for="(item,i) in dati"
          :key="i"
          :src="item.PathFile"
        ></v-carousel-item>
      </v-carousel>
    </v-card>
  </v-dialog>
</template>

<script>
import { get_offerteCarousel } from "@/api/api.offerte.js";

export default {
  props: {
    dialog: { type: Boolean, default: false }
  },

  data: () => ({
    dati: [],
    currentIndex: 0
  }),

  methods: {
    async caricaDati() {
      this.dati = [];

      if (this.dialog == false) return;

      let res = await get_offerteCarousel();

      this.dati = res.data;
    },

    close() {
      this.$emit("close");
    }
  },

  computed: {
    getTitolo() {
      if (this.dati.length == 0) return;

      return this.dati[this.currentIndex].Descrizione;
    }
  },

  watch: {
    dialog() {
      this.caricaDati();
    }
  }
};
</script>